import Notification from "@partials/UI/notifications/modules/Notification";

/**
 * Получает HTML контент из template элемента
 * @param {string} templateId - ID template элемента
 * @returns {string} - HTML контент
 */
function getTemplateContent(templateId) {
    const template = document.getElementById(templateId);
    if (!template) {
        console.error(`Template с ID "${templateId}" не найден`);
        return "";
    }

    // Клонируем содержимое template и возвращаем HTML
    const clone = template.content.cloneNode(true);
    const wrapper = document.createElement("div");
    wrapper.appendChild(clone);
    return wrapper.innerHTML;
}

const successForm = () => getTemplateContent("notification-success-template");
const unsuccessForm = () => getTemplateContent("notification-error-template");

function createInstanceNotification(contentGetter) {
    return new Notification({
        selector: "#notification-modal",
        content: typeof contentGetter === "function" ? contentGetter() : contentGetter,
        close: "#notification-modal .close",
        overlay: "#notification-modal .overlay",
    });
}

export { successForm, unsuccessForm, createInstanceNotification };
